import { FilterMatchMode } from "primereact/api"

export class Interesado {
    model = {
        id: { value: null, export: false },
        actor_interno: {
            header: 'ACTORES INTERNOS',
            value: null,
            required: 'Selecione una opcion',
            optionLabel: 'nombre',
            export: false,
            filterPlaceholder: 'Búsqueda',
            filterField: 'actor_interno',
            filter: true,
            sort: true,
            table: true,
            matchMode: FilterMatchMode.CONTAINS
        },
        actor_externo: {
            header: 'ACTORES EXTERNOS',
            value: null,
            required: 'Selecione una opcion',
            optionLabel: 'nombre',
            export: false,
            filterPlaceholder: 'Búsqueda',
            filterField: 'actor_externo',
            filter: true,
            sort: true,
            table: true,
            matchMode: FilterMatchMode.CONTAINS
        },
    }
}
